/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */
/* eslint max-len: 0 */
import { findPinMode } from './helpers';

// ----------------------- Zumbador piezoelectrico -----------------------------
// Pin 12 fijo: el perfil BHOOT no tiene selector de pin para el buzzer. El quirk
// octave === 3 ? 4 se preserva para que la nota por defecto suene igual en todas las placas.

export const BHOOT_piezo_buzzer = (block) => {
  const value = block.getFieldValue('PIANO');
  const pitch = (value.basePitch * (value.octave === 3 ? 4 : value.octave)) || 131;
  const duration = value.duration || 1000;
  return `tone(12, ${pitch}, ${duration});\n`;
};

export const BHOOT_piezo_buzzer_no_ruration = (block) => {
  const value = block.getFieldValue('PIANO');
  const pitch = (value.basePitch * (value.octave === 3 ? 4 : value.octave)) || 131;
  return `tone(12, ${pitch});\n`;
};

export const BHOOT_piezo_buzzer_variable = (block, generator) => {
  const tone = generator.valueToCode(block, 'VAR', generator.ORDER_NONE);
  const duration = generator.valueToCode(block, 'DURATION', generator.ORDER_NONE);
  return `tone(12, ${tone}, ${duration});\n`;
};

export const BHOOT_piezo_buzzerno = () => {
  return 'noTone(12);\n';
};

// ------------------------------ Cronometro -----------------------------------
// 'BHOOT_chronometer_def' solo declara DevolverCronometro, para que _millis
// compile usado solo, sin el helper que agrega el bloque que arranca el cronómetro.

const CHRONOMETER_VAR_DEF = '\nlong DevolverCronometro;\n';

const CHRONOMETER_HELPER = `
long TiempoCronometro;
boolean CronometroIniciado;

void ejecutarCronometro() {
  if (CronometroIniciado == true) {
    DevolverCronometro =  millis() - TiempoCronometro;
  } else {
    DevolverCronometro = 0;
  }
}
`;

const CHRONOMETER_LOOP = '\n  ejecutarCronometro();\n';

export const BHOOT_chronometer = (block, generator) => {
  generator.definitions_['BHOOT_chronometer_def'] = CHRONOMETER_VAR_DEF;
  generator.definitions_['BHOOT_chronometer'] = CHRONOMETER_HELPER;
  generator.loop_['BHOOT_chronometer_def'] = CHRONOMETER_LOOP;

  return '\n  TiempoCronometro = millis();\n  CronometroIniciado = true;  \n';
};

export const BHOOT_chronometer_millis = (block, generator) => {
  generator.definitions_['BHOOT_chronometer_def'] = CHRONOMETER_VAR_DEF;
  return ['DevolverCronometro', generator.ORDER_ATOMIC];
};

// ------------------------------ Servos ---------------------------------------
// Divergencia deliberada: el legacy de _move_millis agregaba dos espacios tras
// `Servo servo_${pin};\n` y, como la clave se comparte, el resultado dependía del
// orden de los bloques. Se normaliza a la versión de _move y _read.

const includeServo = (generator, pin) => {
  generator.definitions_['include_servo'] = '#include <Servo.h>\n\n';
  generator.definitions_[`include_servo_${pin}`] = `Servo servo_${pin};\n`;
  generator.setups_[`servo_move_${pin}`] = `servo_${pin}.attach(${pin});`;
};

export const BHOOT_servo_move = (block, generator) => {
  const angle = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);
  const pin = block.getFieldValue('NPIN') || '';
  includeServo(generator, pin);
  return `servo_${pin}.write(${angle});\n`;
};

export const BHOOT_servo_move_millis = (block, generator) => {
  const angle = generator.valueToCode(block, 'angulo', generator.ORDER_ATOMIC);
  const millis = generator.valueToCode(block, 'millis', generator.ORDER_ATOMIC);
  const pin = block.getFieldValue('NPIN') || '';

  includeServo(generator, pin);
  generator.definitions_[`include_servo_move_${pin}`] = `
void moverServoGradualmente_${pin}(int angulo, int intervalo) {
  if (servo_${pin}.read() < angulo) {
    for (int i = servo_${pin}.read(); i <= angulo; i++) {
      servo_${pin}.write(i);
      delay(intervalo);
    }
  } else {
    for (int i = servo_${pin}.read(); i >= angulo; i--) {
      servo_${pin}.write(i);
      delay(intervalo);
    }
  }
}
`;

  return `\n  moverServoGradualmente_${pin}(${angle}, ${millis});\n`;
};

export const BHOOT_servo_read = (block, generator) => {
  const pin = block.getFieldValue('NPIN') || '';
  includeServo(generator, pin);
  return [`servo_${pin}.read()`, generator.ORDER_ATOMIC];
};

// ------------------------------ Sensores luz/color/joystick ------------------
// light_color usa también la clave 'BHOOT_light_intensity' para compartir el
// helper del sensor sin duplicarlo.

const LIGHT_SENSOR_DEF = `
#include "MH_TCS34725.h"
MH_TCS34725 tcs = MH_TCS34725(TCS34725_INTEGRATIONTIME_50MS, TCS34725_GAIN_4X);
int intensidadColor_R, intensidadColor_G, intensidadColor_B;
void obtenerColor() {
  uint16_t clear, red, green, blue;
  tcs.getRGBC(&red, &green, &blue, &clear);
  float r,g,b;
  r = red;
  r /= clear;
  g = green;
  g /= clear;
  b = blue;
  b /= clear;
  intensidadColor_R = r*256;
  intensidadColor_G = g*256;
  intensidadColor_B = b*256;
}

int colorEs(int numeroRGB) {
  switch (numeroRGB) {
    case 0:
      if (intensidadColor_R >= intensidadColor_G && intensidadColor_R >= intensidadColor_B) {
        return 1;
      } else {
        return 0;
      }
      break;
    case 1:
      if (intensidadColor_G >= intensidadColor_R && intensidadColor_G >= intensidadColor_B) {
        return 1;
      } else {
        return 0;
      }
      break;
    case 2:
      if (intensidadColor_B >= intensidadColor_R && intensidadColor_B >= intensidadColor_G) {
        return 1;
      } else {
        return 0;
      }
      break;
  }
}

`;

const LIGHT_SENSOR_LOOP = '\n  obtenerColor();\n';

const installLightSensor = (generator) => {
  generator.definitions_['BHOOT_light_intensity'] = LIGHT_SENSOR_DEF;
  generator.loop_['BHOOT_light_intensity'] = LIGHT_SENSOR_LOOP;
};

export const BHOOT_light_intensity = (block, generator) => {
  const color = block.getFieldValue('COLOR');
  installLightSensor(generator);
  return [color, generator.ORDER_ATOMIC];
};

const COLOR_INDEX_BY_RGB = {
  '0, 255, 0': '1',
  '0, 0, 255': '2',
};

export const BHOOT_light_color = (block, generator) => {
  const rgbColor = generator.valueToCode(block, 'COLOR', generator.ORDER_ATOMIC) || 0;
  const color = COLOR_INDEX_BY_RGB[rgbColor] || '0';

  installLightSensor(generator);
  return [`colorEs(${color})`, generator.ORDER_ATOMIC];
};

export const BHOOT_joystick = (block, generator) => {
  const type = block.getFieldValue('TYPE');
  return [type, generator.ORDER_ATOMIC];
};

// ------------------------------ Sensores distancia/infrarrojo ----------------
// 'define_SALIDAS_bat_u_distancia' se comparte con ARDUINOUNO_entradas_ultrasonido
// pero con otra función: si un programa mezcla ambos, gana el último generado.
// Quirk del legacy preservado; el whitespace de los pinMode también es el de prod.

const ULTRASONIDO_U_DISTANCIA = `
int u_distancia(int TriggerPin, int EchoPin) {
    long duration, distanceCm;
    digitalWrite(TriggerPin, LOW);
    delayMicroseconds(4);
    digitalWrite(TriggerPin, HIGH);
    delayMicroseconds(10);
    duration = pulseIn(EchoPin, HIGH);
    distanceCm = duration * 10 / 292/ 2;
    return distanceCm;
}
`;

export const BHOOT_ultrasonido = (block, generator) => {
  const [triggerPin, echoPin] = block.getFieldValue('NPIN').split(',');

  generator.definitions_['define_SALIDAS_bat_u_distancia'] = ULTRASONIDO_U_DISTANCIA;
  generator.setups_[`setup_SALIDAS_bat_${echoPin}${triggerPin}`] = `pinMode( ${echoPin} , INPUT );\n`;
  generator.setups_[`setup_SALIDAS_bat_2${triggerPin}${echoPin}`] = `pinMode( ${triggerPin} , OUTPUT );\n`;

  return [`u_distancia(${triggerPin},${echoPin})`, generator.ORDER_ATOMIC];
};

export const BHOOT_line_follower = (block, generator) => {
  const branchDerecha = generator.statementToCode(block, 'STACK_DERECHA').replace(/&quot;/g, '"');
  const branchCentro = generator.statementToCode(block, 'STACK_CENTRO').replace(/&quot;/g, '"');
  const branchIzquierda = generator.statementToCode(block, 'STACK_IZQUIERDA').replace(/&quot;/g, '"');

  let code = `
    int Bhoot_SeguidorDerecha = analogRead(A0);
    int Bhoot_SeguidorIzquierda = analogRead(A7);
    int Bhoot_SeguidorCentro = analogRead(A1);
`;

  if (branchDerecha !== '') {
    code += `
    if (Bhoot_SeguidorDerecha <= 30 && Bhoot_SeguidorCentro > 30 && Bhoot_SeguidorIzquierda > 30) {
        ${branchDerecha}
    }
`;
  }
  if (branchCentro !== '') {
    code += `
    if (Bhoot_SeguidorDerecha > 30 && Bhoot_SeguidorCentro > 30 && Bhoot_SeguidorIzquierda > 30) {
        ${branchCentro}
    }
`;
  }
  if (branchIzquierda !== '') {
    code += `
    if (Bhoot_SeguidorIzquierda <= 30 && Bhoot_SeguidorCentro > 30 && Bhoot_SeguidorDerecha > 30) {
        ${branchIzquierda}
    }
`;
  }

  return code;
};

export const BHOOT_ENTRADAS_infrared = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  const color = block.getFieldValue('COLOR');
  const colorValue = color === 'white' ? 0 : 1;

  generator.setups_[`setup_infrared_${pin}`] = `pinMode( ${pin} , INPUT);\n`;

  return [`digitalRead(${pin}) == ${colorValue}`, generator.ORDER_ATOMIC];
};

// ------------------------------ Motores DC senior ---------------------------
// controlJuniorBlocks.js también escribe `definitions_.motors` y
// `setups_.setup_motors` con otro contenido: si se mezclaran, gana el último generado.

// VendorID-ProductID USB de la placa Buty v2.
const BUTY_V2_USB_ID = '0X1A86-0X7523';

const isButyV2 = (block) => block.boardVersion?.toUpperCase() === BUTY_V2_USB_ID;

const motorsHelper = (butyV2) => `
const int Bhoot_MI = 7;
const int Bhoot_PWM2 = 6;
const int Bhoot_PWM1 = 5;
const int Bhoot_MD = 4;

void Bhoot_Avanzar(int Bhoot_Velocidad) {
    digitalWrite(Bhoot_MI, LOW);
    digitalWrite(Bhoot_MD, ${butyV2 ? 'LOW' : 'HIGH'});
    analogWrite(Bhoot_PWM1, Bhoot_Velocidad);
    analogWrite(Bhoot_PWM2, Bhoot_Velocidad);
}

void Bhoot_Retroceder(int Bhoot_Velocidad) {
    int invertirVel = ${butyV2 ? 'map(Bhoot_Velocidad, 0, 255, 255, 0);' : 'Bhoot_Velocidad;'}
    digitalWrite(Bhoot_MI, HIGH);
    digitalWrite(Bhoot_MD, ${butyV2 ? 'HIGH' : 'LOW'});
    analogWrite(Bhoot_PWM1, invertirVel);
    analogWrite(Bhoot_PWM2, invertirVel);
}

void Bhoot_Frenar() {
    ${butyV2 ? 'digitalWrite(Bhoot_MI, LOW);' : ''}
    ${butyV2 ? 'digitalWrite(Bhoot_MD, LOW);' : ''}
    analogWrite(Bhoot_PWM1, 0);
    analogWrite(Bhoot_PWM2, 0);
}

void Bhoot_GirarIzquierda(int Bhoot_Velocidad) {
    int invertirVel = ${butyV2 ? 'map(Bhoot_Velocidad, 0, 255, 255, 0);' : 'Bhoot_Velocidad;'}
    digitalWrite(Bhoot_MI, HIGH);
    digitalWrite(Bhoot_MD, ${butyV2 ? 'LOW' : 'HIGH'});
    analogWrite(Bhoot_PWM1, Bhoot_Velocidad);
    analogWrite(Bhoot_PWM2, invertirVel);
}

void Bhoot_GirarDerecha(int Bhoot_Velocidad) {
    int invertirVel = ${butyV2 ? 'map(Bhoot_Velocidad, 0, 255, 255, 0);' : 'Bhoot_Velocidad;'}
    digitalWrite(Bhoot_MI, LOW);
    digitalWrite(Bhoot_MD, ${butyV2 ? 'HIGH' : 'LOW'});
    analogWrite(Bhoot_PWM1, invertirVel);
    analogWrite(Bhoot_PWM2, Bhoot_Velocidad);
}\n`;

const MOTORS_SETUP = `
    pinMode(Bhoot_MI, OUTPUT);
    pinMode(Bhoot_PWM1, OUTPUT);
    pinMode(Bhoot_MD, OUTPUT);
    pinMode(Bhoot_PWM2, OUTPUT);
`;

const installMotorsHelper = (block, generator) => {
  generator.definitions_.motors = motorsHelper(isButyV2(block));
  generator.setups_.setup_motors = MOTORS_SETUP;
};

const MOTOR_DOBLE_FUNCTIONS = {
  3: 'Bhoot_Avanzar',
  4: 'Bhoot_Retroceder',
  5: 'Bhoot_GirarDerecha',
  6: 'Bhoot_GirarIzquierda',
  7: 'Bhoot_Frenar',
};

export const BHOOT_motor_doble = (block, generator) => {
  installMotorsHelper(block, generator);
  const fn = MOTOR_DOBLE_FUNCTIONS[block.getFieldValue('DIR')];
  if (!fn) return '';
  return fn === 'Bhoot_Frenar' ? `${fn}();\n` : `${fn}(255);\n`;
};

export const BHOOT_motor_doble_pwm = (block, generator) => {
  installMotorsHelper(block, generator);
  const pwm = generator.valueToCode(block, 'PWM', generator.ORDER_ATOMIC) || '';
  const dir = block.getFieldValue('DIR');
  const fn = MOTOR_DOBLE_FUNCTIONS[dir];
  if (!fn) return '';
  // El dropdown no ofrece '7', pero si llegara, Bhoot_Frenar no lleva argumento.
  return fn === 'Bhoot_Frenar' ? `${fn}();\n` : `${fn}(${pwm});\n`;
};

// En butyV2, pin1 '7' es el pin MI de la placa y su emisión va invertida.
export const BHOOT_motor_single_speed = (block, generator) => {
  const pwm = generator.valueToCode(block, 'PWM', generator.ORDER_ATOMIC) || '';
  const [pin1, pin2] = block.getFieldValue('NPIN').split(',');
  const butyV2 = isButyV2(block);
  const dir = block.getFieldValue('DIR');
  let code = '';

  switch (dir) {
    case '3': // Girar a la derecha
      if (butyV2 && pin1 === '7') {
        code = `\n  digitalWrite(${pin1}, HIGH);\n  analogWrite(${pin2}, map(${pwm}, 0, 255, 255, 0));\n`;
      } else if (butyV2) {
        code = `\n  digitalWrite(${pin1}, LOW);\n  analogWrite(${pin2}, ${pwm});\n`;
      } else {
        code = `\n  digitalWrite(${pin1}, HIGH);\n  analogWrite(${pin2}, ${pwm});\n`;
      }
      break;
    case '4': // Girar a la izquierda
      if (butyV2 && pin1 === '7') {
        code = `\n  digitalWrite(${pin1}, LOW);\n  analogWrite(${pin2}, ${pwm});\n`;
      } else if (butyV2) {
        code = `\n  digitalWrite(${pin1}, HIGH);\n  analogWrite(${pin2}, map(${pwm}, 0, 255, 255, 0));\n`;
      } else {
        code = `\n  digitalWrite(${pin1}, LOW);\n  analogWrite(${pin2}, ${pwm});\n`;
      }
      break;
    case '6': // Frenar
      if (butyV2) {
        code = `\n  digitalWrite(${pin1}, LOW);\n  digitalWrite(${pin2}, LOW);\n`;
      } else {
        code = `\n  digitalWrite(${pin1}, LOW);\n  analogWrite(${pin2}, 0);\n`;
      }
      break;
    default:
      break;
  }

  generator.setups_[`setup_motors_single_${pin1}`] = `\npinMode(${pin1}, OUTPUT);\npinMode(${pin2}, OUTPUT);\n`;
  return code;
};

// ------------------------------ Neopixels senior ----------------------------

const NEOPIXEL_PIN = 13;

const NEOPIXEL_DEF = `
#include <Adafruit_NeoPixel.h>
#define PIN ${NEOPIXEL_PIN}
#define NUMPIXELS 2

Adafruit_NeoPixel pixels(NUMPIXELS, PIN, NEO_GRB + NEO_KHZ800);\n`;

const NEOPIXEL_LOOP = 'pixels.clear();';

// _maxBrightness escribe las mismas claves con brillo 255: si se combina con
// _neopixel gana el último generado (quirk del legacy preservado).
const installNeopixel = (generator, brightness = 30) => {
  generator.definitions_.def_led_neopixel = NEOPIXEL_DEF;
  generator.setups_.setup_led_neopixel = `pixels.begin();\npixels.setBrightness(${brightness});\n`;
  generator.loop_.bhoot_led_neopixel = NEOPIXEL_LOOP;
};

const neopixelCode = (led, colorArgs) => {
  if (led === '2') {
    return `\npixels.setPixelColor(0, pixels.Color(${colorArgs}));\npixels.setPixelColor(1, pixels.Color(${colorArgs}));\npixels.show();\ndelayMicroseconds(300);\n`;
  }
  return `\npixels.setPixelColor(${led}, pixels.Color(${colorArgs}));\npixels.show();\ndelayMicroseconds(300);\n`;
};

export const BHOOT_led_neopixel = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  const led = block.getFieldValue('LED') || '0';

  installNeopixel(generator);
  return neopixelCode(led, color);
};

export const BHOOT_led_neopixel_maxBrightness = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  const led = block.getFieldValue('LED') || '0';

  installNeopixel(generator, 255);
  return neopixelCode(led, color);
};

export const BHOOT_led_neopixel_clear = (block, generator) => {
  const led = block.getFieldValue('LED') || '0';

  installNeopixel(generator);
  return neopixelCode(led, '0,0,0');
};

// --------------------------- Modulo LED RGB (6 pixels) ----------------------

const LED_RGB_LIB_DEF = '\n#include <Adafruit_NeoPixel.h>\n#define NUMLEDRGB 6\n';

const ledRgbModuleDef = (pin) => `\nAdafruit_NeoPixel MODULOLEDRGB_${pin}(NUMLEDRGB, ${pin}, NEO_GRB + NEO_KHZ800);\n`;

const installLedRgbModule = (generator, pin) => {
  generator.definitions_.bhoot_salidas_led_rgb = LED_RGB_LIB_DEF;
  generator.definitions_[`BHOOT_led_rgb_${pin}`] = ledRgbModuleDef(pin);
  generator.setups_[`BHOOT_led_rgb_${pin}`] = `MODULOLEDRGB_${pin}.begin();\n`;
};

export const BHOOT_led_rgb = (block, generator) => {
  const colours = ['COLOUR1', 'COLOUR2', 'COLOUR3', 'COLOUR4', 'COLOUR5', 'COLOUR6']
    .map((name) => generator.valueToCode(block, name, generator.ORDER_ATOMIC) || 0);
  const pin = block.getFieldValue('NPIN') || '0';

  installLedRgbModule(generator, pin);

  const pixels = colours
    .map((colour, i) => `MODULOLEDRGB_${pin}.setPixelColor(${i}, MODULOLEDRGB_${pin}.Color(${colour}));`)
    .join('\n');

  return `\nMODULOLEDRGB_${pin}.clear();\n${pixels}\nMODULOLEDRGB_${pin}.show();\ndelayMicroseconds(300);\n`;
};

export const BHOOT_led_rgb_single = (block, generator) => {
  const colour = generator.valueToCode(block, 'COLOUR1', generator.ORDER_ATOMIC) || 0;
  const position = generator.valueToCode(block, 'POSITION', generator.ORDER_ATOMIC) || 0;
  const pin = block.getFieldValue('NPIN') || '0';

  installLedRgbModule(generator, pin);

  return `\nMODULOLEDRGB_${pin}.clear();\nMODULOLEDRGB_${pin}.setPixelColor(${position}, MODULOLEDRGB_${pin}.Color(${colour}));\nMODULOLEDRGB_${pin}.show();\ndelayMicroseconds(300);\n`;
};

export const BHOOT_salidas_led_rgb = (block, generator) => {
  const pin = block.getFieldValue('NPIN');
  const r = generator.valueToCode(block, 'DATOINR', generator.ORDER_ATOMIC) || 0;
  const g = generator.valueToCode(block, 'DATOING', generator.ORDER_ATOMIC) || 0;
  const b = generator.valueToCode(block, 'DATOINB', generator.ORDER_ATOMIC) || 0;

  installLedRgbModule(generator, pin);

  return `\nMODULOLEDRGB_${pin}.clear();\nfor (int i = 0; i < NUMLEDRGB; i++) {\n    MODULOLEDRGB_${pin}.setPixelColor(i, MODULOLEDRGB_${pin}.Color(${r}, ${g}, ${b}));\n}\nMODULOLEDRGB_${pin}.show();\ndelayMicroseconds(300);\n`;
};

// ------------------------------ Matriz 8x16 senior --------------------------
// Divergencia deliberada: el bitmap se nombra con `block.id` y no con
// Math.random() como el legacy, para que el código generado sea reproducible.

export const MATRIX16X8_IIC_DEF = `
#define IIC_SCL  A5
#define IIC_SDA  A4
void IIC_start();
void IIC_send(unsigned char send_data);
void IIC_end();

void IIC_start()
{
  digitalWrite(IIC_SCL,LOW);
  delayMicroseconds(3);
  digitalWrite(IIC_SDA,HIGH);
  delayMicroseconds(3);
  digitalWrite(IIC_SCL,HIGH);
  delayMicroseconds(3);
  digitalWrite(IIC_SDA,LOW);
  delayMicroseconds(3);
}
void IIC_send(unsigned char send_data)
{
  for(char i = 0;i < 8;i++)
  {
      digitalWrite(IIC_SCL,LOW);
      delayMicroseconds(3);
      if(send_data & 0x01)
      {
        digitalWrite(IIC_SDA,HIGH);
      }
      else
      {
        digitalWrite(IIC_SDA,LOW);
      }
      delayMicroseconds(3);
      digitalWrite(IIC_SCL,HIGH);
      delayMicroseconds(3);
      send_data = send_data >> 1;
  }
}
void IIC_end()
{
  digitalWrite(IIC_SCL,LOW);
  delayMicroseconds(3);
  digitalWrite(IIC_SDA,LOW);
  delayMicroseconds(3);
  digitalWrite(IIC_SCL,HIGH);
  delayMicroseconds(3);
  digitalWrite(IIC_SDA,HIGH);
  delayMicroseconds(3);
}
`;

export const MATRIX16X8_SETUP = `
pinMode(IIC_SCL,OUTPUT);
pinMode(IIC_SDA,OUTPUT);
digitalWrite(IIC_SCL,LOW);
digitalWrite(IIC_SDA,LOW);
`;

const BHOOT_MATRIX16X8_ROWS = 8;
const BHOOT_MATRIX16X8_COLS = 16;

// El orden de recorrido (desde index 15 hacia abajo, +16 por fila) es el del
// legacy: cambiarlo altera la matriz dibujada en el hardware.
export const encodeMatrix16x8ByteLeds = (leds) => {
  let byteLeds = '{';
  for (let j = 0; j < BHOOT_MATRIX16X8_COLS; j += 1) {
    let index = 15 - j;
    byteLeds += '\n\t0b';
    for (let i = 0; i < BHOOT_MATRIX16X8_ROWS; i += 1) {
      byteLeds += (leds && leds[index]) ? '1' : '0';
      index += 16;
    }
    byteLeds += ',';
  }
  byteLeds += '\n};\n';
  return byteLeds;
};

export const BHOOT_matrix8x16 = (block, generator) => {
  const name = `bitmap_${String(block.id).replace(/[^a-zA-Z0-9]+/g, '')}`;
  // Fallback a `block.leds` para bloques que todavía traen los LEDs en ese
  // formato en vez del valor del campo MATRIX.
  const { leds } = block.getFieldValue ? (block.getFieldValue('MATRIX') || {}) : {};
  const byteLeds = encodeMatrix16x8ByteLeds(leds || block.leds);

  generator.definitions_['define_matrix_8x16'] = MATRIX16X8_IIC_DEF;
  generator.definitions_[`define_matrix_${block.id}`] = `unsigned char ${name}[] = ${byteLeds}`;
  generator.setups_['setup_matriz_8x16'] = MATRIX16X8_SETUP;

  return `
IIC_start();
IIC_send(0x40);
IIC_end();

IIC_start();
IIC_send(0xc0);
for(char i = 0;i < 16;i++)
    IIC_send(${name}[i]);
IIC_end();

IIC_start();
IIC_send(0b10001111);
IIC_end();
`;
};

// ------------------------------ Bluetooth senior ----------------------------
// Cada bloque escribe `setups_.setup_blue` con o sin `\n` final como el legacy;
// gana el último generado. No unificar: cambia el código respecto de prod.

const BLUE_SERIAL_DEF = '#include <SoftwareSerial.h>\nSoftwareSerial BT1(9,8);\n';
const BLUE_SERIAL_BAUD = 9600;

export const BHOOT_bt_serial_available = (block, generator) => {
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  generator.definitions_.blue_serial = BLUE_SERIAL_DEF;
  // Sin `\n` final, como el legacy.
  generator.setups_.setup_blue = `BT1.begin(${BLUE_SERIAL_BAUD});`;

  return `if (BT1.available()>0){\nString mensaje = BT1.readStringUntil('\\n');\nmensaje.trim();\n${branch}\n}\n`;
};

export const BHOOT_bluetooth_name = (block, generator) => {
  let bluetoothName2 = generator.valueToCode(block, 'name', generator.ORDER_ATOMIC) || '';
  bluetoothName2 = bluetoothName2.replace(/"/g, '');
  const butyV2 = isButyV2(block);

  generator.definitions_.blue_serial = BLUE_SERIAL_DEF;
  // Con `\n` final, como el legacy.
  generator.setups_.setup_blue = `BT1.begin(${BLUE_SERIAL_BAUD});\n`;

  let code = '';
  if (butyV2) {
    code += '\nBT1.write("AT\\r\\n");\n';
  }
  code += `\ndelay(5000);\nBT1.${butyV2 ? 'write' : 'print'}("AT+NAME${bluetoothName2}${butyV2 ? '\\r\\n' : ''}");\ndelay(5000);\n`;
  if (butyV2) {
    code += '\nBT1.write("AT+RESET\\r\\n");\ndelay(1000);\n';
  }
  return code;
};

// Los dos espacios tras `}` y la indentación de 4 de BT1.print son del legacy:
// se preservan byte a byte para que el código coincida con prod.
const SERIAL_BLUE_TAG_HELPER = `
void mandarMensajeConEtiqueta(String etiqueta, String content){
  String mensaje = etiqueta + content;
    BT1.print(mensaje);
}  
`;

export const BHOOT_serial_blue_tag = (block, generator) => {
  const contentRaw = generator.valueToCode(block, 'CONTENT', generator.ORDER_ATOMIC);
  const { code: pinModeCode, pin: content } = findPinMode(contentRaw);
  const tag = block.getFieldValue('TAG') || 'A';

  generator.definitions_.blue_serial = BLUE_SERIAL_DEF;
  generator.definitions_.serial_blue_tag = SERIAL_BLUE_TAG_HELPER;
  // Con `\n` final, como el legacy.
  generator.setups_.setup_blue = `BT1.begin(${BLUE_SERIAL_BAUD});\n`;

  return `${pinModeCode}mandarMensajeConEtiqueta("${tag}", String(${content}));\n`;
};

const BLUE_READ_TAG_HELPER = `
int leerNumeroConEtiqueta(String mensajeCompleto, char etiqueta) {
  if (mensajeCompleto.length() > 0 && mensajeCompleto.charAt(0) == etiqueta) {
    String mensajeSinEtiqueta = mensajeCompleto.substring(1);
    int numeroSinEtiqueta = mensajeSinEtiqueta.toInt();
    return numeroSinEtiqueta;
  } else {
    return -1;
  }
}

String leerTextoConEtiqueta(String mensajeCompleto, char etiqueta) {
  if (mensajeCompleto.length() > 0 && mensajeCompleto.charAt(0) == etiqueta) {
    String mensajeSinEtiqueta = mensajeCompleto.substring(1);
    return mensajeSinEtiqueta;
  }
    return "";
}
`;

export const BHOOT_blue_read_tag = (block, generator) => {
  const content = block.getFieldValue('TAG') || 'A';
  const type = block.getFieldValue('TYPE') || 'number';

  generator.definitions_.blue_serial = BLUE_SERIAL_DEF;
  generator.definitions_.blue_read_tag = BLUE_READ_TAG_HELPER;
  // Sin `\n` final, como el legacy.
  generator.setups_.setup_blue = `BT1.begin(${BLUE_SERIAL_BAUD});`;

  const fn = type === 'number' ? 'leerNumeroConEtiqueta' : 'leerTextoConEtiqueta';
  return [`${fn}(mensaje, '${content}')`, generator.ORDER_ATOMIC];
};
